const styles = (theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
  },
})

export default styles
